import { MediaType } from '../../../constants/MediaType';

export const EVERY_NON_SECURE_MEDIA_TYPE_DISABLED = {
  [MediaType.Picture]: false,
  [MediaType.Video]: false,
  [MediaType.Music]: false,
  [MediaType.Document]: false,
  [MediaType.VectorArt]: false,
  [MediaType.SiteIcon]: false,
  [MediaType.ThreeD]: false,
  [MediaType.Zip]: false,
  [MediaType.SWF]: false,
};

export const NONE_NON_SECURE_MEDIA_TYPE_SELECTED = {
  [MediaType.Picture]: false,
  [MediaType.Video]: false,
  [MediaType.Music]: false,
  [MediaType.Document]: false,
  [MediaType.VectorArt]: false,
  [MediaType.ThreeD]: false,
  [MediaType.SWF]: false,
};

export const NONE_NON_SECURE_MEDIA_TYPE_SELECTED_WITH_ZIP = {
  [MediaType.Picture]: false,
  [MediaType.Video]: false,
  [MediaType.Music]: false,
  [MediaType.Document]: false,
  [MediaType.VectorArt]: false,
  [MediaType.ThreeD]: false,
  [MediaType.Zip]: false,
  [MediaType.SWF]: false,
};

export const NONE_WIX_MUSIC_MEDIA_TYPES_SELECTED = {
  [MediaType.SecureMusic]: false,
};

export const NONE_WIX_VIDEO_MEDIA_TYPES_SELECTED = {
  [MediaType.SecureVideo]: false,
};

export const NONE_ART_STORE_MEDIA_TYPES_SELECTED = {
  [MediaType.SecurePicture]: false,
};

export const NONE_DIGITAL_PRODUCT_MEDIA_TYPES_SELECTED = {
  [MediaType.SecurePicture]: false,
  [MediaType.SecureMusic]: false,
  [MediaType.SecureDocument]: false,
  [MediaType.SecureZip]: false,
};

export const ALL_NON_SECURE_MEDIA_TYPES_SELECTED = {
  [MediaType.Picture]: true,
  [MediaType.Video]: true,
  [MediaType.Music]: true,
  [MediaType.Document]: true,
  [MediaType.VectorArt]: true,
  [MediaType.ThreeD]: true,
  [MediaType.SWF]: true,
};

export const ALL_NON_SECURE_MEDIA_TYPES_SELECTED_WITH_ZIP = {
  [MediaType.Picture]: true,
  [MediaType.Video]: true,
  [MediaType.Music]: true,
  [MediaType.Document]: true,
  [MediaType.VectorArt]: true,
  [MediaType.ThreeD]: true,
  [MediaType.Zip]: true,
  [MediaType.SWF]: true,
};

export const ALL_WIX_MUSIC_MEDIA_TYPES_SELECTED = {
  [MediaType.SecureMusic]: true,
};

export const ALL_WIX_VIDEO_MEDIA_TYPES_SELECTED = {
  [MediaType.SecureVideo]: true,
};

export const ALL_ART_STORE_MEDIA_TYPES_SELECTED = {
  [MediaType.SecurePicture]: true,
};

export const ALL_DIGITAL_PRODUCT_MEDIA_TYPES_SELECTED = {
  [MediaType.SecurePicture]: true,
  [MediaType.SecureMusic]: true,
  [MediaType.SecureDocument]: true,
  [MediaType.SecureZip]: true,
};

export const MEDIA_TYPE_ALL_SELECTED = {
  [MediaType.All]: true,
};
